import { render, staticRenderFns } from "./CandidateInterviewV2.vue?vue&type=template&id=4baeb80a&scoped=true&"
import script from "./CandidateInterviewV2.vue?vue&type=script&lang=ts&"
export * from "./CandidateInterviewV2.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateInterviewV2.vue?vue&type=style&index=0&id=4baeb80a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baeb80a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VCol,VIcon,VImg,VProgressCircular,VRow,VSkeletonLoader,VTextarea})
